export default class DtoExploitationMatRep {
    constructor(obj) {
        this.idExploitation = obj.idExploitation // Long,
        this.idElement1 = obj.idElement1 // Long,
        this.repartition = obj.repartition // Option[Double],
        this.idElement2 = obj.idElement2 // Long,
        this.linkType = obj.linkType // Int
    }
}